// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- ambient global.d.ts has no runtime JS counterpart to import
/// <reference path="./global.d.ts" />
import { DynamicYieldClient } from "./client";
import { ensureDynamicYieldGlobal, whenDynamicYieldCoreReady } from "./consent";
import {
  getUserConsentDecision,
  whenUserConsentDecisionKnown,
} from "@jetblue/dotcom-trust-arc";
import { logError } from "@jetblue/dotcom-fe-logger";

const DY_RECOMMENDATION_CONTEXT_TYPE_HOMEPAGE = "HOMEPAGE";
const DY_RECOMMENDATION_CONTEXT_TYPE_OTHER = "OTHER";

export const setPageContext = ({
  currentUrl,
  isHomePage,
  language: lng = "en",
}: {
  currentUrl?: string;
  isHomePage?: boolean;
  language?: string;
}) => {
  const dy = ensureDynamicYieldGlobal();

  if (isHomePage) {
    dy.recommendationContext = {
      lng,
      type: DY_RECOMMENDATION_CONTEXT_TYPE_HOMEPAGE,
    };
  } else if (currentUrl) {
    dy.recommendationContext = {
      data: [{ url: currentUrl }],
      lng,
      type: DY_RECOMMENDATION_CONTEXT_TYPE_OTHER,
    };
  }
};

const DY_LOGIN_EVENT_NAME = "Login";
const DY_LOGIN_CUID_TYPE = "TrueBlueNumber";
const DY_LOGIN_TYPE = "login-v1";

export const handleLogin = async (tbNumber: string) => {
  await whenUserConsentDecisionKnown();
  if (!getUserConsentDecision()?.functional) {
    return;
  }

  try {
    await whenDynamicYieldCoreReady();
  } catch {
    void logError({ message: "Dynamic Yield initialization failed" });
    return;
  }

  if (!getUserConsentDecision()?.functional) {
    return;
  }

  const dy = globalThis.DY;

  if (typeof dy?.API !== "function") {
    return;
  }

  dy.API("event", {
    name: DY_LOGIN_EVENT_NAME,
    properties: {
      cuid: tbNumber,
      cuidType: DY_LOGIN_CUID_TYPE,
      dyType: DY_LOGIN_TYPE,
    },
  });
};
export { updateDynamicYieldConsent } from "./consent";
export type DynamicYieldProperites = {
  sectionId: string | undefined;
  language: string;
};

const DynamicYield = ({ sectionId, language }: DynamicYieldProperites) => (
  <>
    <link href="https://cdn.dynamicyield.com" rel="preconnect" />
    <link href="https://st.dynamicyield.com" rel="preconnect" />
    <link href="https://rcom.dynamicyield.com" rel="preconnect" />
    <link href="https://cdn.dynamicyield.com" rel="dns-prefetch" />
    <link href="https://st.dynamicyield.com" rel="dns-prefetch" />
    <link href="https://rcom.dynamicyield.com" rel="dns-prefetch" />
    <DynamicYieldClient language={language} sectionId={sectionId} />
  </>
);

export default DynamicYield;
